import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer flex items-center gap-1">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-600" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-400 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}